import { Form, PageState } from "../components/TypeDefinitions";

export function getForm(state: PageState): Form | null {
  const form = state.data.inspectionTypeTemplate.configuration.forms.find(
    (form) => form.id === state.formId
  );
  if (form === undefined) return null;
  return form;
}
